// 青绿色主题配置 - 清新、自然、活力
export const greenTheme = {
  colors: {
    'psychology-primary': '#10b981',      // 青绿色 - 主色调，清新活力
    'psychology-secondary': '#f59e0b',    // 温暖橙色 - 辅助色，温暖活力
    'psychology-accent': '#65a30d',       // 深绿色 - 强调色，自然
    'psychology-calm': '#f0fdf4',         // 浅青绿 - 背景色，清新
    'psychology-warm': '#f7fdee',         // 浅黄绿 - 温暖背景
    'psychology-success': '#059669',      // 深青绿 - 成功状态
    'psychology-info': '#0d9488',         // 青色 - 信息状态
    'psychology-warning': '#d97706',      // 橙色 - 警告状态
  },
  name: 'green',
  description: '清新青绿色主题 - 自然、活力、健康'
}
